<div class="tabbable__body margin--none clearfix shadow-z-1">
  <div class="block">
    <h3 class="text--medium thin">
      Här listas månadsrapporterna som visar estimerat lager per månad. De sammanställs under natten den första dagen varje månad.
    </h3>
  </div>
  <app-woo-table [data]="monthlyReports">
    <woo-table-column header="Månad" name="description"></woo-table-column>
    <woo-table-column header="Skapad" name="created_at">
      <ng-template #cell let-cell>
        {{cell.value | date}}
      </ng-template>
    </woo-table-column>
    <woo-table-column header="" name="actions">
      <ng-template #cell let-cell>
        <button (click)="downloadReport(cell.row)" class="button primary-1 margin--none">
          <span class="text--medium">
            <span class="icon-download"></span> Ladda ner
          </span>
        </button>
      </ng-template>
    </woo-table-column>
  </app-woo-table>
</div>
